import { Union } from 'ts-toolbelt';

import {
  BANNER_HORIZON_URN,
  BANNER_RISETERM_URN,
} from 'containers/Estimates/OffboardingEstimates/constants';
import { Source } from 'types/graph';
import optimizely from 'util/optimizely';
import { Flags } from 'util/optimizely/types';

interface Options {
  productUrn: Union.Nullable<string>;
  lifeApplicationSource: Source | undefined;
  customerAge: Union.Nullable<number>;
  coverageAmount: Union.Nullable<number>;
  tableRating: Union.Nullable<string>;
}
export const LGA_DIGITAL_MAX_COVERAGE = 2_000_000;

export const isEligibleForApplyOnline = ({
  productUrn,
  lifeApplicationSource,
  customerAge,
  coverageAmount,
  tableRating,
}: Options) => {
  const bannerFlagOn = optimizely.isFeatureEnabled(Flags.BANNER_DSS_FLOW_ENABLED, 'life-web');

  if (
    !bannerFlagOn ||
    lifeApplicationSource === Source.Pgpro ||
    disableLGADigitalApplyForApp(customerAge, coverageAmount, tableRating)
  ) {
    return false;
  }

  // Prefer RiseTerm; if not matched, fall back to Horizon; otherwise ineligible.
  if (productUrn === BANNER_RISETERM_URN) {
    return true;
  }

  if (productUrn === BANNER_HORIZON_URN) {
    return true;
  }

  return false;
};

const disableLGADigitalApplyForApp = (
  customerAge: Union.Nullable<number>,
  coverageAmount: Union.Nullable<number>,
  tableRating: Union.Nullable<string>
) => {
  const disableLGADigitalApplyOn = optimizely.isFeatureEnabled(Flags.DISABLE_LGA_DIGITAL_APPLY);

  if (!disableLGADigitalApplyOn) {
    return false;
  }

  return (
    (customerAge && customerAge >= 61) ||
    (coverageAmount && coverageAmount > LGA_DIGITAL_MAX_COVERAGE) ||
    (tableRating && parseInt(tableRating, 10) >= 4)
  );
};
